export default class SupportMailCheck {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this._inputSelector = document.getElementById('mailToCheck');
    this._inputSelector.addEventListener('keyup', () => {
      this.checkMailAddress();
    });
  }

  checkMailAddress() {
    const _respondSelector = $('#checkRespond');
    const mailAdress = this._inputSelector.value;
    // if (mailAdress.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
    if (mailAdress.match(/[a-z0-9._-]+@[a-z0-9-.]+\.[a-z]{2,}/)) {
      $.post(
        'ajax_edit.php',
        {
          mode: 'mailCheck',
          val: mailAdress,
          json: true
        },
        respond => {
          _respondSelector.html(respond.message).fadeIn('slow');
        },
        'json'
      );
    } else {
      _respondSelector.fadeOut('slow');
    }
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/support_mail_check.js